import { del, get, post, put } from "../api";

export async function getAdminAlloVoisinsAutomation(query = "", filter = "all", take = 100) {
    const params = new URLSearchParams();
    if (query) {
        params.set("query", query);
    }
    if (filter && filter !== "all") {
        params.set("filter", filter);
    }
    params.set("take", take);

    return await get(`userprofile/allovoisins/automation?${params.toString()}`);
}

export async function replaceAdminAlloVoisinsTerms(toolPublicId, terms) {
    return await put({ terms }, `userprofile/allovoisins/automation/tools/${toolPublicId}/terms`);
}

export async function updateAdminAlloVoisinsAutomationSettings(settings) {
    return await put(settings, "userprofile/allovoisins/automation/settings");
}

export async function addAdminAlloVoisinsTerm(toolPublicId, term) {
    return await post({ term }, `userprofile/allovoisins/automation/tools/${toolPublicId}/terms`);
}

export async function deleteAdminAlloVoisinsTerm(toolPublicId, termId) {
    return await del(`userprofile/allovoisins/automation/tools/${toolPublicId}/terms/${termId}`);
}

export async function getAdminAlloVoisinsSuggestions(toolPublicId) {
    return await get(`userprofile/allovoisins/automation/tools/${toolPublicId}/suggestions`);
}

export async function updateAdminAlloVoisinsAlsoAvailable(toolPublicId, text) {
    return await put({ text }, `userprofile/allovoisins/automation/tools/${toolPublicId}/also-available`);
}
